var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "brb-modal" },
    [
      !_vm.noActivator
        ? _c(
            "div",
            { staticClass: "brb-modal-activator" },
            [
              _vm._t(
                "activator",
                function () {
                  return [
                    !_vm.noActivator
                      ? _c(
                          _vm.activatorTag,
                          _vm._b(
                            { tag: "component", on: { click: _vm.show } },
                            "component",
                            _vm.activatorAttrs,
                            false
                          ),
                          [
                            _vm.activatorIcon
                              ? _c("font-awesome-icon", {
                                  class: _vm.activatorIconClass,
                                  attrs: { icon: _vm.activatorIcon },
                                })
                              : _vm._e(),
                            _c("span", [
                              _vm._v(" " + _vm._s(_vm.activatorLabel) + " "),
                            ]),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                },
                { show: _vm.show, hide: _vm.hide }
              ),
            ],
            2
          )
        : _vm._e(),
      _c(
        "b-modal",
        _vm._b(
          {
            attrs: {
              "content-class": [
                "rounded-modal",
                { "overflow-hidden": !_vm.showOverflow },
              ],
              "body-class": "p-0",
              "hide-header": "",
              "hide-footer": "",
            },
            model: {
              value: _vm.open,
              callback: function ($$v) {
                _vm.open = $$v
              },
              expression: "open",
            },
          },
          "b-modal",
          _vm.$attrs,
          false
        ),
        [
          !_vm.noHeader
            ? _c(
                "div",
                {
                  staticClass:
                    "head d-flex align-items-center justify-content-between bg-light p-3",
                },
                [
                  _vm._t(
                    "header",
                    function () {
                      return [
                        _c("h4", {
                          staticClass: "text-muted p-0 m-0 single-line",
                          domProps: { innerHTML: _vm._s(_vm.title) },
                        }),
                      ]
                    },
                    { show: _vm.show, hide: _vm.hide }
                  ),
                  _vm.closeButton
                    ? _c(
                        "b-btn",
                        {
                          attrs: {
                            variant: "link",
                            size: "sm",
                            disabled: _vm.loading,
                          },
                          on: { click: _vm.hide },
                        },
                        [
                          _c("font-awesome-icon", {
                            staticClass: "text-muted align-middle",
                            attrs: { icon: "xmark" },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                2
              )
            : _vm._e(),
          _c(
            "b-overlay",
            { attrs: { show: _vm.loading } },
            [
              _vm._t("default"),
              _vm._t(
                "footer",
                function () {
                  return [
                    !_vm.noFooter
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "foot d-flex align-items-center justify-content-end bg-light p-3",
                          },
                          [
                            _c(
                              "brb-btn",
                              _vm._b(
                                {
                                  staticClass: "px-4 ml-2",
                                  attrs: { variant: "brb-red" },
                                  on: { click: _vm.cancel },
                                },
                                "brb-btn",
                                _vm.cancelBind,
                                false
                              ),
                              [_vm._v(" " + _vm._s(_vm.cancelLabel) + " ")]
                            ),
                            _c(
                              "brb-btn",
                              _vm._b(
                                {
                                  attrs: { variant: "brb-secondary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.$emit("submit", {
                                        show: _vm.show,
                                        hide: _vm.hide,
                                      })
                                    },
                                  },
                                },
                                "brb-btn",
                                _vm.submitBind,
                                false
                              ),
                              [_vm._v(" " + _vm._s(_vm.submitLabel) + " ")]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                },
                { show: _vm.show, hide: _vm.hide }
              ),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }